<template>
  <div class="edit-employe" v-loading="loading">
    <el-backtop target=".edit-employe"></el-backtop>
    <header-top showBack haveTab></header-top>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="基本信息">
        <basic-info ref="info" @loading="init" ></basic-info>
      </el-tab-pane>
      <!-- <el-tab-pane label="员工成长" name="员工成长">
        <growth></growth>
      </el-tab-pane> -->
      <el-tab-pane label="资料附件" name="资料附件">
        <material-accessories></material-accessories>
      </el-tab-pane>      
      <!-- <el-tab-pane label="员工异动记录" name="员工异动记录">
        <change-record v-if="activeName=='员工异动记录'"></change-record>
      </el-tab-pane> -->
      <el-tab-pane label="操作记录" name="操作记录">
        <operation-record></operation-record>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
var tabName = "";

import headerTop from "@/components/HeaderTop";
import basicInfo from "./basic-info";
import changeRecord from "./change-record";
import operationRecord from "./operation-record";
import growth from "./growth";
import materialAccessories from "./material-accessories";

export default {
  components: {
    headerTop,
    basicInfo,
    changeRecord,
    operationRecord,
    growth,
    materialAccessories
  },
  data() {
    return {
      headerText: "分销人员",
      activeName: "基本信息",
      loading:true,
    };
  },
  created() {
    if (tabName) {
      this.activeName = tabName;
    }
  },
  methods: {
    handleClick(tab, event) {
      //console.log(tab, event);
      tabName = this.activeName;
      //console.log(tabName,'tabName');
      if (tabName=='基本信息') {
        this.$refs.info.init()
      }
    },
    init(v){
      this.loading=v;
    }
  },
  mounted() {
    //console.log(this.$route, "route");
  }
};
</script>

<style lang="scss" scoped>
.edit-employe {
  ::v-deep .el-tabs__content {
    padding: 20px;
  }
}
</style>